import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { userResetPassword } from "../../../../src/API/Users/userService";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import {
  resetPasswordSchema,
  UserResetPasswordFormValues,
} from "./user-zod-schema";

export function ResetPassword() {
  const form = useForm<UserResetPasswordFormValues>({
    resolver: zodResolver(resetPasswordSchema),
  });

  const [loading, setLoading] = useState(false);

  const router = useNavigate();

  const onSubmit = async (data: UserResetPasswordFormValues) => {
    setLoading(true);
    await userResetPassword(data, router);
    setLoading(false);
  };

  return (
    <div className="pt-24 pb-80">
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="max-w-md p-6 mx-auto bg-white border rounded-lg shadow-md"
      >
        <h2 className="mb-6 text-xl font-semibold text-center">
          Votre adresse email
        </h2>

        <div className="mb-4">
          <div className="relative">
            <Input
              id="newPassword"
              type={"text"}
              {...form.register("email")}
              placeholder="E-mail"
            />
          </div>
          {form.formState.errors.email && (
            <p className="mt-1 text-sm text-red-500">
              {form.formState.errors.email.message}
            </p>
          )}
        </div>

        {/* Submit Button */}
        <Button type="submit" isLoading={loading} className="w-full">
          Envoyer
        </Button>
      </form>
    </div>
  );
}
